import {useState, useEffect} from 'react';

export const useClientConfig = () => {
    const [config, setConfig] = useState(null);

    useEffect(() => {
        fetch('/config/client-config.json')
            .then(response => response.json())
            .then(data => setConfig(data))
            .catch(err => console.error('Config error:', err));
    }, []);

    return config;
};